<template>
	<lv-base-column
		ref="column" v-bind="columnBinding">
		<template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
			<link-table-column-toggle-item
				:row="row"
				:edit-row="editRow"
				:row-index="rowIndex"
				:col="col"
				:col-index="colIndex"
				:fixed-row="fixedRow"
				v-bind="columnItemBinding"
				@click.native="lv_clickItem({row,rowIndex,editRow})"

				:size="size"
				:color="color"
				:true-value="trueValue"
				:false-value="falseValue"
			/>
		</template>
	</lv-base-column>
</template>

<script>
	import {ColumnMixin} from "../mixins";
	import LinkTableColumnToggleItem from "./link-table-column-toggle-item";
	import LvBaseColumn from "../../table/lv-base-column";

	export default {
		name: 'link-table-column-toggle',
		components: {
			LvBaseColumn,
			LinkTableColumnToggleItem,
		},
		mixins: [ColumnMixin],
		props: {
			fastRender: {default: false},

			width: {default: 80},
			size: {default: 'small'},
			color: {default: 'primary',},
			search: {default: false},
			align: {default: 'center'},

			trueValue: {default: 'Y'},
			falseValue: {default: 'N'},
			translate: {
				default() {
					return (val) => {
						if (val === this.trueValue) return '是'
						if (val === this.falseValue) return '否'
						return val
					}
				},
			},
		},
	};
</script>
